import logo from './logo.svg';
import React, {Suspense, lazy, useEffect, useState} from 'react';
import './App.css';
import RTL from "./Rtl";
import configureStore, {history} from './redux/store';
import './assets/css/style.css'
import {ThemeProvider, createTheme} from '@mui/material/styles';
import {BrowserRouter, Route, Routes, Switch} from 'react-router-dom';
import {CircularProgress} from '@mui/material';
import {GetPrize, GetCredit, CheckToken, LoginView} from "./api/api";

import {useDispatch, useSelector} from "react-redux";
import {savecredit,saveday,saveplane} from "./redux/actions/contactsApp";

const theme = createTheme({
    direction: 'rtl',
    fontFamily: 'iransans'
});
const HomePage = React.lazy(() => import('./views/HomePage/HomePage'));
const Prizes = React.lazy(() => import('./views/prizes/Prizes'));
const MyPrizes = React.lazy(() => import('./views/MyPrizes/MyPrizes'));
const DetailsPrize = React.lazy(() => import('./views/DetailsPrize/DetailsPrize'));
const DetailsPlane = React.lazy(() => import('./views/DetailsPlane/DetailsPlane'));
const Orders = React.lazy(() => import('./views/Orders/Orders'));
const Login = React.lazy(() => import('./views/Login/Login'));
const Blank = React.lazy(() => import('./views/Blank/Blank'));
const Plane = React.lazy(() => import('./views/Plane/Plane'));


const store = configureStore();


function App() {

    const dispatch = useDispatch();
    const [show, setShow] = useState(true);


    useEffect(() => {
        // alert('ads');
        GetCredit()
            .then((response) => {
                if (response.data.errorCode === 0) {
                    // alert(response.data.Credit)

                    dispatch(savecredit(response.data.Credit));
                    dispatch(saveplane(response.data.Plane));
                    dispatch(saveday(response.data.Day));
                }
            })
            .catch((error) => {
            });
        //  console.log('user_id')
        // alert(localStorage.getItem('user_id'));
        //
        // if (localStorage.getItem('user_id') === '' || localStorage.getItem('user_id') === null) {
        //     setShow(false);
        //     // navigate("/login");
        // } else {
        //     setShow(true);
        //     // CheckToken()
        //     //     .then((response) => {
        //     //         if (response.data.errorCode === 0) {
        //     //              setShow(true);
        //     //         }else {
        //     //              setShow(false);
        //     //         }
        //     //     })
        //     //     .catch((error) => {
        //     //     });
        //
        //
        //
        //
        // }
         window.dispatchEvent(new CustomEvent("navigationhandler"));

    }, []);










    const load = () => {


        return <div className="loading">

            <div className="loadingchild">
                <CircularProgress/>

            </div>


        </div>;


    }


    return (
        // <div className="App">
        //   <header className="App-header">
        //     <img src={logo} className="App-logo" alt="logo" />
        //     <p>
        //       Edit <code>src/App.js</code> and save to reload.
        //     </p>
        //     <a
        //       className="App-link"
        //       href="https://reactjs.org"
        //       target="_blank"
        //       rel="noopener noreferrer"
        //     >
        //       Learn React
        //     </a>
        //   </header>
        // </div>

        <RTL>
            <ThemeProvider theme={theme}>
                <BrowserRouter basename="/">

                    <div className="main-wrapper">


                        {/*<div style={{textAlign:'center'}} >*/}
                        {/*  armin*/}

                        {/*</div>*/}

                        {/*<Tabs*/}
                        {/*    variant="fullWidth"*/}
                        {/*    value={0}*/}
                        {/*    aria-label="icon position tabs example"*/}
                        {/*>*/}
                        {/*    <Tab icon={<FavoriteIcon/>} iconPosition="start"  label={<span className="title-tab">جوایز</span>}/>*/}
                        {/*    <Tab icon={<FavoriteIcon/>} iconPosition="start" label="سفارشات"/>*/}
                        {/*    <Tab icon={<FavoriteIcon/>} iconPosition="start" label="جوایز دریافتی"/>*/}
                        {/*    /!*<Tab icon={<FavoriteIcon/>} iconPosition="start" label="bottom"/>*!/*/}
                        {/*</Tabs>*/}
                        {/*<HomePage/>*/}

                        {/*<Switch>*/}

                        {/*    <Route path="/" exact render={() => <Suspense fallback={load()}> <HomePage/> </Suspense>}/>*/}

                        {/*    /!*<Route path="/addoffender" exact*!/*/}
                        {/*    /!*       render={() => <Suspense fallback={load()}> <NewOffender/> </Suspense>}/>*!/*/}

                        {/*    /!*<Route render={() => <h1>not Found</h1>}/>*!/*/}

                        {/*</Switch>*/}

                        {show ?

                            <Routes>

                                {/*<Route path="/" exact element={<HomePage />} />*/}
                                <Route path="/" exact element={<Prizes/>}/>
                                {/*<Route path="/prizes" exact element={<Prizes/>}/>*/}
                                <Route path="/redirect" exact element={<Login/>}/>
                                <Route path="/redirect/:mytoken" exact element={<Login/>}/>
                                <Route path="/detailsprizes/:id" exact element={<DetailsPrize/>}/>
                                <Route path="/detailsplane/:id" exact element={<DetailsPlane/>}/>
                                <Route path="/myprizes" exact element={<MyPrizes/>}/>
                                <Route path="/score" exact element={<Orders/>}/>
                                <Route path="/blank" exact element={<Blank/>}/>
                                <Route path="/plane" exact element={<Plane/>}/>

                                <Route path='*' element={<Blank />}/>

                                {/*<Route path="/" component={HomePage}/>*/}
                                {/*<Route path="/one" component={Prizes}/>*/}
                                {/*<Route path="/two" component={Prizes}/>*/}
                            </Routes>


                            :
                            <Routes>

                                <Route path="/redirect" exact element={<Login/>}/>

                            </Routes>
                        }


                        {/*<Prizes/>*/}


                    </div>
                </BrowserRouter>
            </ThemeProvider>
        </RTL>


    );
}

export default App;
